import {UserDTO} from './UserDTO'
import {Model} from '../model/Model'

export class User extends Model<UserDTO> {

    public is_logged_in!: boolean
    public name?: string
    public login_url?: string
    public logout_url?: string
    public has_multi_user?: boolean
    public multi_user_url?: string

    constructor(initial?: Partial<UserDTO>) {
        super()
        this.init(initial)
    }
}
